export default __webpack_public_path__ + "assets/d7735ccd54c4c5506549f72a945a9fc9.png";